import { signal } from "@preact/signals-react";
import { QueuedSong } from "stuen-common";

export const queue = signal<QueuedSong[]>([]);
